import TableHead from '@material-ui/core/TableHead';

/** @deprecated */
export default TableHead;
